'use client'

import { XMarkIcon } from '@heroicons/react/24/outline'

export const TopNavMobileCloseHeader = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="flex items-center justify-end p-4 pb-0">
      <button
        className="rounded-md p-1 text-bodi-white transition-colors hover:bg-bodi-gray-dark"
        onClick={onClick}
      >
        <XMarkIcon className="size-6 stroke-[2px]" />
      </button>
    </div>
  )
}
